export function calculateDuration(
  arrival: string | Date,
  departure?: string | Date
): string {
  const startTime = new Date(arrival).getTime()
  // If departure is not provided, calculate duration until now for ongoing visits
  const endTime = departure ? new Date(departure).getTime() : Date.now()

  // Ensure diff is non-negative
  const diff = Math.max(0, endTime - startTime)

  const hours = Math.floor(diff / (1000 * 60 * 60))
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

  if (hours === 0) {
    return `${minutes}m`
  }
  return `${hours}h ${minutes}m`
}

export function formatTime(
  dateInput: string | Date | undefined,
  placeholder: string = '---'
): string {
  if (!dateInput) {
    return placeholder
  }
  const date = new Date(dateInput)
  return date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
}
